import { avalanche, mainnet, bsc, polygon, arbitrum, optimism, fantomOpera } from '../../../../../packages/wagmi' 
// need later version with avalanche and fantom

export const CHAINS_STARGATE = [avalanche, mainnet, bsc, polygon, arbitrum, optimism, fantomOpera]


/* { avalanche, bsc, mainnet, arbitrum, optimism, polygon, fantomOpera }  */